import { Controller } from "@hotwired/stimulus"

// Generic multi-step wizard for the booking forms. Each panel is a
// `data-booking-wizard-target="step"`. Only one step is visible at a time;
// next()/back() move between them. Leaving the first step requires a treatment
// and a chosen time slot. A read-only summary (target "summary") is filled from
// the step-1 choices when entering step 2. Slot loading is handled separately
// by the dashboard-booking / hotel-booking controller.
export default class extends Controller {
  static targets = ["step", "summary"]

  connect() {
    this.current = this.stepTargets.findIndex((el) => !el.classList.contains("hidden"))
    if (this.current < 0) this.current = 0
    this.showStep(this.current)
  }

  next() {
    if (this.current === 0 && !this.step1Valid()) return
    if (!this.currentStepValid()) return

    if (this.current < this.stepTargets.length - 1) {
      this.showStep(this.current + 1)
      if (this.current === 1) this.renderSummary()
    }
  }

  back() {
    if (this.current > 0) this.showStep(this.current - 1)
  }

  showStep(i) {
    this.current = i
    this.stepTargets.forEach((el, idx) => el.classList.toggle("hidden", idx !== i))
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  step1Valid() {
    const treatment = this.field("booking-treatment-select")
    const startsAt = this.field("booking-starts-at")
    const slotError = this.element.querySelector('[data-slot-error]') ||
      this.element.querySelector('[data-dashboard-booking-target="slotError"]') ||
      this.element.querySelector('[data-hotel-booking-target="slotError"]')

    if (treatment?.value && startsAt?.value) {
      if (slotError) slotError.classList.add("hidden")
      return true
    }
    if (slotError) {
      slotError.classList.remove("hidden")
      slotError.scrollIntoView({ behavior: "smooth", block: "center" })
    }
    return false
  }

  currentStepValid() {
    const fields = this.stepTargets[this.current].querySelectorAll("input, select, textarea")
    const firstInvalid = Array.from(fields).find((field) => !field.checkValidity())

    if (!firstInvalid) return true

    firstInvalid.reportValidity()
    return false
  }

  renderSummary() {
    if (!this.hasSummaryTarget) return

    const treatment = this.field("booking-treatment-select")
    const date = this.field("booking-date")
    const startsAt = this.field("booking-starts-at")
    const therapist = this.field("booking-therapist-select")

    const treatmentName = treatment?.selectedOptions?.[0]?.text || "-"
    const slotBtn = startsAt?.value ? this.element.querySelector(`[data-starts-at="${startsAt.value}"]`) : null
    const time = slotBtn ? slotBtn.textContent.trim() : "-"
    const therapistName = therapist?.value ? (therapist.selectedOptions?.[0]?.text || "-") : "Otomatis"

    this.summaryTarget.innerHTML = [
      this.row("Perawatan", treatmentName),
      this.row("Tanggal", date?.value || "-"),
      this.row("Waktu", time),
      this.row("Terapis", therapistName),
    ].join("")
  }

  row(label, value) {
    const safe = String(value).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]))
    return `<div class="flex justify-between gap-4"><span class="text-olive">${label}</span><span class="font-medium text-right">${safe}</span></div>`
  }

  field(testid) {
    return this.element.querySelector(`[data-testid="${testid}"]`)
  }
}
